import { TransparentButton } from '@approvalmax/ui';
import { State } from 'modules/data';
import { AppleAppStore, GooglePlay } from 'modules/sprites';
import { font } from 'modules/styles';
import { FC, memo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { MobileDeviceId, MobileInfoModuleData } from '../reducers/page/moduleReducer';
import { getModule } from '../selectors/pageSelectors';
import { mobileAppUrls } from './MobileInfoModule.constants';
import { messages } from './MobileInfoModule.messages';

const Container = styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    display: flex;
    flex-flow: column;
    align-items: center;
`;

const Body = styled.div`
    width: 100%;
    flex: 1;
    padding: 20px 40px;
    display: flex;
    flex-flow: column;
    align-items: center;
`;

const Description = styled.div`
    text-align: center;
    margin-bottom: 40px;
    ${font(14, '#fff')}
`;

const MobileInfoModule: FC = () => {
    const module = useSelector((state: State) => getModule<MobileInfoModuleData>(state));

    const downloadIPhoneApp = () => {
        window.location.href = mobileAppUrls.ios;
    };

    const downloadAndroidApp = () => {
        window.location.href = mobileAppUrls.android;
    };

    return (
        <Container>
            <Body>
                <Description>{messages.description({ br: <br /> })}</Description>

                {module.device === MobileDeviceId.IPhone && (
                    <TransparentButton execute={downloadIPhoneApp}>
                        <AppleAppStore width={175} height={50} />
                    </TransparentButton>
                )}

                {module.device === MobileDeviceId.Android && (
                    <TransparentButton execute={downloadAndroidApp}>
                        <GooglePlay width={175} height={50} />
                    </TransparentButton>
                )}
            </Body>
        </Container>
    );
};

export default memo(MobileInfoModule);
